<template>
  <a-card :bordered='false'>
    <!-- 查询区域 -->
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='24'>
          <a-col :xl='6' :lg='7' :md='8' :sm='24'>
            <mtc-form-item label='label.languageName' :labelCol='{ span: 5 }'>
              <a-input :placeholder="$t('label.pleaseEnterlanguageName')" v-model='queryParam.languageName'></a-input>
            </mtc-form-item>
          </a-col>
          <a-col :xl='6' :lg='7' :md='8' :sm='24'>
            <mtc-form-item label='label.languageCode' :labelCol='{ span: 5 }'>
              <a-input :placeholder="$t('label.pleaseEnterlanguageCode')" v-model='queryParam.languageCode'></a-input>
            </mtc-form-item>
          </a-col>
          <!--<template v-if="toggleSearchStatus">-->
          <a-col :xl='6' :lg='7' :md='8' :sm='24'>
            <mtc-form-item label='label.remarks' :labelCol='{ span: 5 }'>
              <a-input :placeholder="$t('label.pleaseEnterANote')" v-model='queryParam.description'></a-input>
            </mtc-form-item>
          </a-col>
          <!--</template>-->
          <a-col :xl='6' :lg='7' :md='8' :sm='24'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <!--<a-button type="primary" @click="searchQuery" icon="search">查询</a-button>-->
              <!--<a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>-->
              <mtc-button @click='searchQuery' type='primary' icon='search' text='button.search'></mtc-button>
              <mtc-button @click='searchReset' type='primary' icon='reload' style='margin-left: 8px' text='button.reset'></mtc-button>
              <!--<a @click="handleToggleSearch" style="margin-left: 8px">-->
              <!--{{ toggleSearchStatus ? '收起' : '展开' }}-->
              <!--<a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>-->
              <!--</a>-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class='table-operator'>
      <!--<a-button @click="handleAdd" type="primary" icon="plus">{{ $t('button.add') }}</a-button>-->
      <mtc-button @click='handleAdd' type='primary' icon='plus' text='button.add'></mtc-button>
      <!--<a-button type="primary" icon="download" @click="handleExportXls('语言信息维护')">导出</a-button>-->
      <mtc-button @click="handleExportXls('语言信息维护')" type='primary' icon='download' text='button.export'></mtc-button>
      <a-upload name='file' :showUploadList='false' :multiple='false' :headers='tokenHeader' :action='importExcelUrl' @change='handleImportExcel'>
        <!--<a-button type="primary" icon="import">导入</a-button>-->
        <mtc-button type='primary' icon='import' text='button.import'></mtc-button>
      </a-upload>
      <a-dropdown v-if='selectedRowKeys.length > 0'>
        <a-menu slot='overlay'>
          <a-menu-item key='1' @click='batchDel'>
            <a-icon type='delete' />
            {{ $t('button.delete') }}
          </a-menu-item>
        </a-menu>
        <!--<a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>-->
        <mtc-button style='margin-left: 8px' text='button.batchOperation'></mtc-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class='ant-alert ant-alert-info' style='margin-bottom: 16px;'>
        <i class='anticon anticon-info-circle ant-alert-icon'></i> {{ $t('tip.selected') }} <a style='font-weight: 600'>{{ selectedRowKeys.length }}</a>{{ $t('tip.term') }}
        <a style='margin-left: 24px' @click='onClearSelected'>{{ $t('button.clear') }}</a>
      </div>

      <a-table
        ref='table'
        size='middle'
        bordered
        rowKey='id'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='ipagination'
        :loading='loading'
        :rowSelection='{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}'
        class='j-table-force-nowrap'
        @change='handleTableChange'>

        <template v-for='(item, index) in columns' :slot='item.slotName'>
          <!--<span :key="index">{{ $t(item.slotName) }}</span>-->
          <mtcHeader :key='index' :text='item.slotName' />
        </template>

        <template slot='htmlSlot' slot-scope='text'>
          <div v-html='text'></div>
        </template>
        <template slot='imgSlot' slot-scope='text'>
          <span v-if='!text' style='font-size: 12px;font-style: italic;'>无图片</span>
          <img v-else :src='getImgView(text)' height='25px' alt='' style='max-width:80px;font-size: 12px;font-style: italic;' />
        </template>
        <template slot='fileSlot' slot-scope='text'>
          <span v-if='!text' style='font-size: 12px;font-style: italic;'>无文件</span>
          <a-button
            v-else
            :ghost='true'
            type='primary'
            icon='download'
            size='small'
            @click='uploadFile(text)'>
            下载
          </a-button>
        </template>

        <span slot='action' slot-scope='text, record'>
          <!--<a @click="handleEdit(record)">{{ $t('button.edit') }}</a>-->
          <mtc-button @click='handleEdit(record)' type='link' size='small' text='button.edit'></mtc-button>
          <a-divider type='vertical' />
          <a-dropdown>
            <!--<a class="ant-dropdown-link">{{ $t('button.more') }} <a-icon type="down" /></a>-->
            <mtc-button type='link' size='small' text='button.more'></mtc-button>
            <a-menu slot='overlay'>
              <a-menu-item>
                <a-popconfirm :title="$t('tip.isDelete')" @confirm='() => handleDelete(record.id)'>
                  <!--<a>{{ $t('button.delete') }}</a>-->
                   <mtc-button type='link' size='small' text='button.delete'></mtc-button>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <sysLanguageConfiguration-modal ref='modalForm' @ok='modalFormOk'></sysLanguageConfiguration-modal>
  </a-card>
</template>

<script>

import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import SysLanguageConfigurationModal from './modules/SysLanguageConfigurationModal'
import { MTC_AUTH } from '@api/servers'

export default {
  name: 'SysLanguageConfigurationList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    SysLanguageConfigurationModal
  },
  data(){
    return {
      description: '语言信息维护管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function( t, r, index ){
            return parseInt(index) + 1
          }
        },
        // {
        //   slotName: 'tableHeader.userAccount',
        //   // title: '用户账号',
        //   align: "center",
        //   dataIndex: 'username',
        //   width: 120,
        //   sorter: true,
        //   scopedSlots: { title: 'tableHeader.userAccount'}
        // },
        {
          slotName: 'label.languageName',
          // title:'语言名称',
          align: 'center',
          sorter: true,
          dataIndex: 'languageName',
          scopedSlots: { title: 'label.languageName' }
        },
        {
          slotName: 'label.languageCode',
          // title:'语言编码',
          align: 'center',
          dataIndex: 'languageCode',
          scopedSlots: { title: 'label.languageCode' }
        },
        {
          slotName: 'tableHeader.sort',
          // title:'排序',
          align: 'center',
          dataIndex: 'seq',
          scopedSlots: { title: 'tableHeader.sort' }
        },
        {
          slotName: 'label.remarks',
          // title:'备注',
          align: 'center',
          dataIndex: 'description',
          scopedSlots: { title: 'label.remarks' }
        },
        /*{
          title:'创建人',
          align:"center",
          dataIndex: 'createBy'
        },
        {
          title:'创建时间',
          align:"center",
          dataIndex: 'createTime',
          customRender:function (text) {
            return !text?"":(text.length>10?text.substr(0,10):text)
          }
        },
        {
          title:'修改人',
          align:"center",
          dataIndex: 'updateBy'
        },
        {
          title:'修改时间',
          align:"center",
          dataIndex: 'updateTime',
          customRender:function (text) {
            return !text?"":(text.length>10?text.substr(0,10):text)
          }
        },
        {
          title:'所属部门编码',
          align:"center",
          dataIndex: 'sysOrgCode'
        },
        {
          title:'备注,后台用',
          align:"center",
          dataIndex: 'notes'
        },*/
        {
          slotName: 'tableHeader.whetherValid',
          // title:'是否有效',
          align: 'center',
          dataIndex: 'validFlag_dictText',
          scopedSlots: { title: 'tableHeader.whetherValid' }
        },
        // {
        //   title:'主要语言',
        //   align:"center",
        //   dataIndex: 'mainLanguage_dictText'
        // },
        // {
        //   title:'次要语言',
        //   align:"center",
        //   dataIndex: 'secondLanguage_dictText'
        // },
        /* {
           title:'是否删除',
           align:"center",
           dataIndex: 'delFlag'
         },*/
        /*{
          title:'租户信息',
          align:"center",
          dataIndex: 'tenantCode'
        },*/
        {
          slotName: 'tableHeader.operation',
          // title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action', title: 'tableHeader.operation' },
          align: 'center',
          width: 170
        }
      ],
      url: {
        list: `${ MTC_AUTH }system/sysLanguageConfiguration/list`,
        delete: `${ MTC_AUTH }system/sysLanguageConfiguration/setDeleteFlag`,
        deleteBatch: `${ MTC_AUTH }system/sysLanguageConfiguration/deleteBatch`,
        exportXlsUrl: `${ MTC_AUTH }system/sysLanguageConfiguration/exportXls`,
        importExcelUrl: `${ MTC_AUTH }system/sysLanguageConfiguration/importExcel`
      },
      dictOptions: {}
    }
  },
  computed: {
    importExcelUrl: function(){
      return `${ window._CONFIG[ 'domianURL' ] }/${ this.url.importExcelUrl }`
    }
  },
  methods: {
    initDictConfig(){
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>